import { type OnesaasConsent } from "../components/CookieBanner/onesaas-consent-cookie";
import type { TrackEventPayload } from "./types";

const cookieConsentPurposeMapping: Record<
  "Functional" | "Marketing" | "Analytical",
  keyof OnesaasConsent
> = {
  Functional: "onesaascookie_acceptance",
  Analytical: "onesaascookie_performance",
  Marketing: "onesaascookie_targeting",
};

export const hasUserConsentedToEvent = (
  eventpayload: TrackEventPayload,
  isConsentRequired = true,
  givenConsent: Partial<OnesaasConsent> = {}
) => {
  if (!isConsentRequired) {
    return true;
  }

  if (!eventpayload.purposes) {
    console.warn(
      eventpayload.name,
      "Event payload does not have purposes defined. Assuming user has not consented."
    );
    return false;
  }
  return eventpayload.purposes.every(
    (purpose) => givenConsent[cookieConsentPurposeMapping[purpose]] === "true"
  );
};
